module.exports = __webpack_public_path__ + "static/media/greenglove.eee7825d.svg";